export abstract class BaseStore {
  /**
   * Is called when a user logs out. Clean up any data that might remain from the previously
   * logged in user.
   */
  clear() {
    // clear
  }
  /**
   * Overwrite and extend this to setup reactions and other things
   * that depend on stores being created.
   * This is called after(!) rootStore initialization, which ensures that all other stores
   * are initialized by the time the reaction is setup. This ensures that all observables are
   * initialized properly.
   *
   * Note:   Dont forget the super call!
   * Note 2: Since this is supposed to be overwritten but the super method called,
   *         this cannot be written as an arrow function.
   */
  init() {
    // init
  }
}
